import type { Component } from '../../common/model/types.tsx';
import type { State } from '../reducer.tsx';

export const isEmpty = (state: State) => state.components.list.length === 0;
export const getIds = (state: State) => state.components.list;
export const getAris = (state: State) => state.components.listAri;

export const getName = (state: State, id: string) => state.components.byId[id].name;
export const getIssueCount = (state: State, id: string) => state.components.byId[id].issueCount;
export const getLead = (state: State, id: string) => state.components.byId[id].lead;
export const getDescription = (state: State, id: string) => state.components.byId[id].description;
export const getDefaultAssignee = (state: State, id: string) =>
	state.components.byId[id].defaultAssignee;
export const getComponent = (state: State, id: string): Component => state.components.byId[id];
export const getTotalItems = (state: State) => state.components.totalItems;
